import React, { useState, useEffect } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	FormFeedback,
	FormGroup,
	ModalFooter,
	Badge,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
// import { addNewGuideDetail, updateGuideDetail } from '../../../../slices/guideDetail/thunk';
// import { setRequireCloseModal } from '../../../../slices/guideDetail/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { getOriginTypeList, getRecordTypeList, getResidueCategoryList, getResidueList, getResidueTypeList, getUnitMeasurementList } from '../../../helpers/residue/backend_helper';
import OSelect from '../../../Components/OElements/OSelect';
import MapCoordinatePicker from '../../../Components/General/Map/MapCoordinatePicker';
import { extractGPSFromImage } from '../utils/imageExifExtractor';
// import { getGuideDetailCategoryList, getGuideDetailTypeList } from '../../../../helpers/guideDetail/backend_helper';
// import { getGuideDetailTypeList } from '../../../../helpers/guideDetail/backend_helper';

const PhotographicRecordForm = ({
    dataPhotographicRecord,
	isEdit,
	handleToggleModal,
	isOpen,
    photographicRecordsList,
    handlePhotographicRecordsList,
	selectedSector,
	dataBeachCleaning
}) => {
	const dispatch = useDispatch();
	const [selectedGuideDetailCategory, setSelectedGuideDetailCategory] = useState(null);
	const handleGuideDetailCategorySelected = (optionSelected) => {
		setSelectedGuideDetailCategory(optionSelected);
	};

    const [selectedRecordType, setSelectedRecordType] = useState(null);
	const handleRecordTypeSelected = (optionSelected) => {
		setSelectedRecordType(optionSelected);
	};

	// GPS coordinates state
	const [coordinates, setCoordinates] = useState(null);
	const [showMap, setShowMap] = useState(false);
	const [isExtractingGPS, setIsExtractingGPS] = useState(false);

	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
            record_type_id: '',
            photographic_record: ''
		},
		validationSchema: Yup.object({
            record_type_id: Yup.string().required('Campo requerido'),
		}),
		onSubmit: values => {
			const selectedOrCurrentRecordType = selectedRecordType || dataPhotographicRecord?.record_type || null;
			const selectedOrCurrentDocument = values.photographic_record || dataPhotographicRecord?.document || null;
			const recordTypeId = values.record_type_id || dataPhotographicRecord?.record_type_id || selectedOrCurrentRecordType?._id || selectedOrCurrentRecordType?.id;

			if (!recordTypeId) {
				toast.error('Debe seleccionar el tipo de registro.', { autoClose: 3000 });
				return;
			}

			if (!selectedOrCurrentDocument) {
				toast.error('Debe adjuntar un registro fotográfico.', { autoClose: 3000 });
				return;
			}

			const newPhotographicRecord = {
				record_type_id: recordTypeId,
				record_type: selectedOrCurrentRecordType || {
					id: recordTypeId,
					_id: recordTypeId,
					name: '',
				},
				document: selectedOrCurrentDocument,
				latitude: coordinates?.latitude || dataPhotographicRecord?.latitude,
				longitude: coordinates?.longitude || dataPhotographicRecord?.longitude,
				...(dataPhotographicRecord?.id && { id: dataPhotographicRecord.id }),
				...(dataPhotographicRecord?.document_id && { document_id: dataPhotographicRecord.document_id }),
			};

			if (isEdit) {
				const isAdded = handlerItemPhotographicRecord(newPhotographicRecord);
				if (isAdded) {
					handleToggleModal(!isOpen);
				}
			} else {
				const isAdded = handlerItemPhotographicRecord(newPhotographicRecord, false);
				if(isAdded){
					handleToggleModal(!isOpen);
				}
				if(isAdded){
					validation.setFieldValue('record_type_id', '');
					validation.setFieldValue('photographic_record', '');
				}
			}
		},
	});

    function handlerItemPhotographicRecord(newPhotographicRecord) {
		let residueAdded = false;
		// const photographicRecordFounded = photographicRecordsList.find(photographicRecord => (
        // ));

		if (isEdit) {
			const updatedPhotographicRecords = photographicRecordsList.map((photographicRecord) => {
				const currentId = photographicRecord?.id || photographicRecord?.document_id;
				const editingId = dataPhotographicRecord?.id || dataPhotographicRecord?.document_id;
				const isSameRecord = currentId && editingId
					? currentId === editingId
					: photographicRecord === dataPhotographicRecord;

				return isSameRecord
					? { ...photographicRecord, ...newPhotographicRecord }
					: photographicRecord;
			});
			handlePhotographicRecordsList(updatedPhotographicRecords);
			residueAdded = true;
			toast.success('Registro fotográfico actualizado exitosamente.', { autoClose: 3000 });
		} else {
			handlePhotographicRecordsList([...photographicRecordsList, newPhotographicRecord]);
			residueAdded = true;
			toast.success('Registro fotográfico agregado exitosamente.', { autoClose: 3000 });
		}
		// if (photographicRecordFounded && !isEdit) {
		// 	toast.error(`Ya existe el residuo recolectado "${newPhotographicRecord.residue.name}".`, { autoClose: 3000 });
		// }

		return residueAdded;
	}

    const handleFileChange = async (event) => {
		const file = event.currentTarget.files[0];
		if (!file) return;

		validation.setFieldValue("photographic_record", file);
		setIsExtractingGPS(true);

		try {
			// Try to extract GPS from image EXIF metadata
			const gpsCoords = await extractGPSFromImage(file);

			if (gpsCoords) {
				// GPS found in image EXIF
				setCoordinates({
					latitude: gpsCoords.latitude,
					longitude: gpsCoords.longitude,
					source: 'exif'
				});
				setShowMap(true);
			} else {
				// No GPS in image, use establishment/sector fallback
				const selectedEstablishment = selectedSector?.establishment || dataBeachCleaning?.sector?.establishment;
				const fallbackLat = selectedEstablishment?.latitude || -33.4489; // Default: Santiago, Chile
				const fallbackLng = selectedEstablishment?.longitude || -70.6693;

				setCoordinates({
					latitude: fallbackLat,
					longitude: fallbackLng,
					source: 'establishment'
				});
				setShowMap(true);
			}
		} catch (error) {
			console.error('Error processing image GPS:', error);
			// Fallback to establishment coordinates on error
			const selectedEstablishment = selectedSector?.establishment || dataBeachCleaning?.sector?.establishment;
			const fallbackLat = selectedEstablishment?.latitude || -33.4489;
			const fallbackLng = selectedEstablishment?.longitude || -70.6693;

			setCoordinates({
				latitude: fallbackLat,
				longitude: fallbackLng,
				source: 'establishment'
			});
			setShowMap(true);
		} finally {
			setIsExtractingGPS(false);
		}
	};

	useEffect(() => {
		if (dataPhotographicRecord) {
			validation.setFieldValue('record_type_id', dataPhotographicRecord.record_type_id || dataPhotographicRecord.record_type?._id || '');
		}
	}, [dataPhotographicRecord]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={'1'}>
					<TabPane tabId='1'>
						<Row className='g-3'>
                            <Col lg={12}>
                                <OSelect
                                    key={`record_type_id` || ''}
                                    label='Tipo de Registro'
                                    id='record_type_id'
                                    name='record_type_id'
									value={validation.values.record_type_id || ''}
                                    onSelect={handleRecordTypeSelected}
                                    requestApi={() => getRecordTypeList()}
                                    disabled={(
                                        isEdit
                                        ? true
                                        : false
                                    )}
                                    validation={validation}
                                />
							</Col>
                            <Col lg={12}>
								<Label for="photographic_record">
									Registro fotográfico
								</Label>
								<Input
									id="photographic_record"
									name="photographic_record"
									type="file"
									accept="image/*"
									onChange={handleFileChange}
									disabled={isExtractingGPS}
								/>
								{isExtractingGPS && (
									<div className="text-muted small mt-1">
										<i className="mdi mdi-loading mdi-spin me-1"></i>
										Extrayendo coordenadas GPS de la imagen...
									</div>
								)}
								{validation.errors.photographic_record && (
									<div className="invalid-feedback d-block">
										{validation.errors.photographic_record}
									</div>
								)}
							</Col>
							{showMap && coordinates && (
								<Col lg={12}>
									<div className="mb-2">
										<div className="text-muted small mb-2">
											Lat: {coordinates.latitude.toFixed(6)}, Lng: {coordinates.longitude.toFixed(6)}
										</div>
									</div>
									<MapCoordinatePicker
										initialLatitude={coordinates.latitude}
										initialLongitude={coordinates.longitude}
										onCoordinatesChange={(newCoords) => {
											setCoordinates({
												...newCoords,
												source: 'manual'
											});
										}}
									/>
								</Col>
							)}
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<ModalFooter>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='button'
						className='btn btn-label btn-primary'
						onClick={() => {
							validation.handleSubmit();
						}}
					>
						<i className='ri-save-line label-icon'></i>
						Guardar
					</button>
				</div>
			</ModalFooter>
		</Form>
	);
};

export default PhotographicRecordForm;
